const SET_UNSENT_SUBMISSION_STATUS = 'SET_UNSENT_SUBMISSION_STATUS';

/**
 * When the submission status indicates that there is unsent data.
 */
export const setUnsentSubmissionStatus = (isUnsent) => {
    return {
        type: SET_UNSENT_SUBMISSION_STATUS,
        isUnsent
    };
};



// WEBPACK FOOTER //
// ./application/containers/SubmissionStatus/actions.js